import StartRecordingIcon from "../../assets/images/start_recording.svg";
import HelloAppLogo from "../../assets/images/hello-logo.svg";

import "./styles.scss";

function GettingStarted() {
    return (
        <div className="d-flex flex-column gap-2">
            <div>
                <img src={HelloAppLogo} alt="Hello App Logo" width={150} />
            </div>
            <div className="d-flex flex-column g-3">
                <h1 className="line">Ready when you are...</h1>
                <h1 className="d-inline-flex gap-2 flex-wrap line fw-bold">
                    Press the <span className="listen-text-banner">Listen Button</span>
                    <img
                        src={StartRecordingIcon}
                        width={40}
                        height={40}
                        alt="Start Recording Icon"
                        className="mx-2 bg-dark rounded-5"
                    />
                    below,
                </h1>
                <h1 className="line">Speak in your language, and I’ll handle the rest.</h1>
            </div>
        </div>
    )
}

export default GettingStarted;
